import React,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { cotizacion,regresar } from './reducers/todo-reducer';
import $ from 'jquery';
import ModalComponent from './ModalCmpt';



class Cotizacion extends Component{

    constructor(props){
        super(props);
        this.state={
            reahorro:false,
            mensaje:{},
            cotizacion:null,
            ahorro_mensual:"",
            loading: false
        }
    }

    componentDidMount(){
        $(window).scrollTop(0);
        this.opcionMedidaTexto(this.props.cotizacion.data);

        this.setState({cotizacion:this.props.cotizacion.data,ahorro_mensual:this.props.cotizacion.data.values.ahorro_mensual});
        console.log(this.props.cotizacion.data);
    }



    componentWillReceiveProps(nextProps){
        if(nextProps.successCotiza === null){
            this.setState({loading:false});
             this.opcionMedidaTexto(nextProps.cotizacion.data);
             
            this.setState({cotizacion:nextProps.cotizacion.data,ahorro_mensual:nextProps.cotizacion.data.values.ahorro_mensual});
        }
    }

    opcionMedidaTexto(cotizacion){
            if(cotizacion.opcionMedida){
                if(cotizacion.opcionMedida.texto){
                    this.setState({
                        propsModal:{exito:false,texto:cotizacion.opcionMedida.texto},
                        mostrar:true
                    });
                }
            }
    }

    render(){

        if(!this.state.cotizacion){
            return (
            <div className="gnp-loading">
                <div className="circle-orange"></div>
                <div className="circle-blue"></div>
                <div className="logo"><img src="https://storage.googleapis.com/static-portalcorporativo.gnp.com.mx/images/site/logo_header @1x.svg" 
                className="fr-fic fr-dib" /></div>
            </div>
            )
        }


        return(

            <div>
                 <div className=" hidden-xs">
                    <div className="divResultadoDesk col-md-12 col-sm-12 col-lg-12">
                        <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul" style={{marginTop:"10px",marginBottom:"10px"}}>
                            Para recibir mensualmente el <span className="requiredIn">{this.state.cotizacion.values.porSueldo}%</span>
                             de tu ingreso (<span className="requiredIn">
                             ${this.formatCurrency((this.state.cotizacion.values.ingreso*this.state.cotizacion.values.porSueldo)/100)}</span>
                             ) a partir de los <span className="requiredIn">{this.state.cotizacion.values.edadretiro}</span>
                              años, es necesario que ahorres desde hoy el <span className="requiredIn">{this.state.cotizacion.aportaciones.porcentaje}%</span>
                               de éste (<span className="requiredIn">${this.formatCurrency(this.state.cotizacion.aportaciones.mensual)}</span>).
                        </div>
                    </div>


                    <div className="divResultadoDesk col-md-12 col-sm-12 col-lg-12">
                    
                        <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul"  style={{marginTop:"10px"}}>
                            Ahorrar con  <span className="requiredIn">GNP Seguros</span>  te brinda múltiples beneficios: 
                        </div>
                        <br/><br/>
                        <div className="col-md-4 col-sm-4 col-lg-4">
                            <div className="col-md-10 col-sm-10 col-lg-10 "  id="otro" style={{background:"white",minHeight:"100px"}}>
                                <ul>
                                    <li>Garantizar por contrato el monto que recibirás.</li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-md-4 col-sm-4 col-lg-4" >
                            <div className="col-md-10 col-sm-10 col-lg-10"  id="otro" style={{background:"white",minHeight:"100px"}}>
                                <ul>
                                    <li>Obtener beneficios Fiscales mientras ahorras.</li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-md-4 col-sm-4 col-lg-4" >
                            <div className="col-md-10 col-sm-10 col-lg-10 " id="otro" style={{background:"white",minHeight:"100px",marginBottom:"10px"}}>
                                <ul>
                                    <li>Ajuste automático por inflación.
                                        ¡El monto que recibirás nunca pierde valor con el paso del tiempo!.</li>
                                </ul>
                            </div>
                        </div>

                      

                    </div>

                    <div className="divResultadoDesk col-md-12 col-sm-12 col-lg-12" >
                        <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul" style={{marginTop:"10px",marginBottom:"10px"}}>
                            Y siempre encontrarás una opción a tu medida...
                        </div>
                        <p><br/></p>

                        { this.parseInte(this.state.ahorro_mensual) > 0 ? 
                           <div>
                            <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul"  style={{marginTop:"10px",marginBottom:"10px"}}>
                                {
                                 (this.state.cotizacion.values.edadretiro - this.state.cotizacion.values.edad_actual ) < 10 ? 
                                 <div>
                                   Ahorrando <span className="requiredIn">${this.formatCurrency(this.state.cotizacion.res.nprima)}
                                   </span> pesos mensuales de manera constante  <span className="requiredIn">garantizas</span> 
                                   un monto mensual de <span className="requiredIn">${this.formatCurrency(this.state.cotizacion.opcionMedida.monto)}
                                   </span> pesos durante <span className="requiredIn">{this.state.cotizacion.values.anios_pension}</span> 
                                   años a partir de los <span className="requiredIn">{this.state.cotizacion.values.edadretiro}</span> años. 
                                </div> 
                                    : 
                                <div>
                                    Ahorrando <span className="requiredIn">${this.formatCurrency(this.state.cotizacion.res.nprima)}</span> 
                                    pesos mensuales de manera constante garantizas un monto mensual de <span className="requiredIn">
                                    ${this.formatCurrency(this.state.cotizacion.opcionMedida.monto)}</span> pesos durante 
                                    <span className="requiredIn">{this.state.cotizacion.values.anios_pension}</span> años a partir de los 
                                    <span className="requiredIn">{this.state.cotizacion.values.edadretiro}</span> años. 
                                    <span>Además... Como un beneficio de <span className="requiredIn">GNP Seguros</span>
                                    , si llegaras a faltar, tus seres queridos recibirán el monto contemplado para tu Retiro (
                                    <span className="requiredIn">${this.formatCurrency(this.state.cotizacion.opcionMedida.sumaAsegurada)}
                                    </span> más la inflación acumulada). </span>

                                </div>
                             }
                            </div>

                            
                            { this.state.reahorro ?

                                <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul"  style={{marginTop:"10px",marginBottom:"10px"}}>
                                    <div className="form-group">
                                        <label htmlFor="ahorro_mensualcot">Ahorrando <span className="requiredIn">*</span></label>
                                        <input type="text" maxLength="6" className="form-control browser-default" id="ahorro_mensualcot" name="ahorro_mensualcot"
                                        value={this.state.ahorro_mensualcot ? this.state.ahorro_mensualcot : ""}
                                        onChange={this.changeValues.bind(this)}/>
                                        {
                                            this.state.mensaje ? 
                                                this.validationMsj(this.state.mensaje.ahorro_mensualcot)
                                            :null
                                        }
                                        
                                    </div>
                                </div>
                                : null }
                            


                            <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center"  style={{marginTop:"10px",marginBottom:"10px"}}>
                                <button className="btn btn-gnp" onClick={this.regresar.bind(this)}>Regresar</button>&nbsp;&nbsp;
                                
                                {this.state.reahorro ? <button className="btn btn-gnp" onClick={this.recotizar.bind(this)}>Recotizar</button> 
                                :
                                <button className="btn btn-gnp-modahorro" onClick={this.muestraAhorro.bind(this)}>Modificar ahorro mensual</button>
                                }
                            </div>
                            </div>
                        : 
                         <div>
                             <div className=" col-md-5 col-sm-5 col-lg-5 etiquetaAzul">
                             <label htmlFor="ahorro_mensualcot">¿Cuánto puedo ahorrar mensualmente para mi retiro? <span className="requiredIn">*</span></label>
                             </div>
                                <div className=" col-md-4 col-sm-4 col-lg-4 etiquetaAzul">
                                    <div className="form-group">
                                            
                                            <input type="text" maxLength="6" className="form-control browser-default" id="ahorro_mensualcot" name="ahorro_mensualcot"
                                            value={this.state.ahorro_mensualcot ? this.state.ahorro_mensualcot : ""}
                                            onChange={this.changeValues.bind(this)}/>
                                            {
                                                this.state.mensaje ? 
                                                    this.validationMsj(this.state.mensaje.ahorro_mensualcot)
                                                :null
                                            }
                                            
                                        </div>
                                </div>
                            

                                <div className=" col-md-12 col-sm-12 col-lg-12 text-center" style={{marginTop:"10px",marginBottom:"10px"}}>
                                
                                    <button className="btn btn-gnp" onClick={this.cotizar.bind(this)}>Cotizar</button>
                                </div>

                            </div> 
                        }

                    </div>

                    
                 </div>

                <div className="formulario-cotiza contenidoFormulario hidden-md hidden-sm hidden-lg">
                    <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center" style={{marginTop:"10px",marginBottom:"10px"}}>
                        Para recibir mensualmente el <span className="requiredIn">{this.state.cotizacion.values.porSueldo}%</span> de tu ingreso 
                        (<span className="requiredIn">${this.formatCurrency((this.state.cotizacion.values.ingreso*this.state.cotizacion.values.porSueldo)/100)}</span>) 
                        a partir de los <span className="requiredIn">{this.state.cotizacion.values.edadretiro}</span> años, es necesario que ahorres desde hoy el 
                        <span className="requiredIn">{this.state.cotizacion.aportaciones.porcentaje}%</span> de éste (<span className="requiredIn">
                        ${this.formatCurrency(this.state.cotizacion.aportaciones.mensual)}</span>).
                    </div>

                    <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center"  style={{marginTop:"10px"}}>
                        Ahorrar con  <span className="requiredIn">GNP Seguros</span>  te brinda múltiples beneficios: 
                    </div>

                    <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul" id="otro" style={{marginTop:"10px"}}>
                       <ul>
                            <li>Garantizar por contrato el monto que recibirás.</li>
                            <li>Obtener beneficios Fiscales mientras ahorras.</li>
                            <li>Ajuste automático por inflación. El monto que recibirás nunca pierde valor con el paso del tiempo!</li>
                        </ul>
                    </div>

                    <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center"  style={{marginTop:"10px"}}>
                        Y siempre encontrarás una opción a tu medida... 
                    </div>
                    { this.parseInte(this.state.ahorro_mensual) > 0 ? 
                        <div>
                            <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center"  style={{marginTop:"10px",marginBottom:"10px"}}>
                            
                             {
                                 (this.state.cotizacion.values.edadretiro - this.state.cotizacion.values.edad_actual ) < 10 ? 
                                 <div>
                                   Ahorrando <span className="requiredIn">${this.formatCurrency(this.state.cotizacion.res.nprima)}</span> 
                                   pesos mensuales de manera constante  <span className="requiredIn">garantizas</span> un monto mensual de 
                                   <span className="requiredIn">${this.formatCurrency(this.state.cotizacion.opcionMedida.monto)}</span> pesos durante 
                                   <span className="requiredIn">{this.state.cotizacion.values.anios_pension}</span> años a partir de los 
                                   <span className="requiredIn">{this.state.cotizacion.values.edadretiro}</span> años. 
                                </div> 
                                    : 
                                <div>
                                    Ahorrando <span className="requiredIn">${this.formatCurrency(this.state.cotizacion.res.nprima)}</span> 
                                    pesos mensuales de manera constante garantizas un monto mensual de <span className="requiredIn">
                                    ${this.formatCurrency(this.state.cotizacion.opcionMedida.monto)}</span> pesos durante 
                                    <span className="requiredIn">{this.state.cotizacion.values.anios_pension}</span> años a partir de los 
                                    <span className="requiredIn">{this.state.cotizacion.values.edadretiro}</span> años. <span>Además... Como un beneficio de 
                                    <span className="requiredIn">GNP Seguros</span>, si llegaras a faltar, tus seres queridos recibirán el monto contemplado para tu Retiro (
                                    <span className="requiredIn">${this.formatCurrency(this.state.cotizacion.opcionMedida.sumaAsegurada)}</span> más la inflación acumulada). 
                                    </span>

                                </div>
                             }
                                
                                
                            </div>

                            
                            { this.state.reahorro ?

                                <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center"  style={{marginTop:"10px",marginBottom:"10px"}}>
                                    <div className="form-group">
                                        <label htmlFor="ahorro_mensualcot">Ahorrando <span className="requiredIn">*</span></label>
                                        <input type="text" maxLength="6" className="form-control browser-default" id="ahorro_mensualcot" name="ahorro_mensualcot"
                                        value={this.state.ahorro_mensualcot ? this.state.ahorro_mensualcot : ""}
                                        onChange={this.changeValues.bind(this)}/>
                                        {
                                            this.state.mensaje ? 
                                            this.validationMsj(this.state.mensaje.ahorro_mensualcot)
                                            :null
                                        }
                                        
                                    </div>
                                </div>
                                : null }
                            


                            <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center"  style={{marginTop:"10px",marginBottom:"10px"}}>
                                <button className="btn btn-gnp" onClick={this.regresar.bind(this)}>Regresar</button>
                                
                                {this.state.reahorro ? <button className="btn btn-gnp" onClick={this.recotizar.bind(this)}>Recotizar</button> 
                                :
                                <button className="btn btn-gnp-modahorro" onClick={this.muestraAhorro.bind(this)}>Modificar ahorro mensual</button>
                                }
                            </div>
                            </div>
                            : 
                            <div>
                                <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center"  style={{marginTop:"10px",marginBottom:"10px"}}>
                                    <div className="form-group">
                                        <label htmlFor="ahorro_mensualcot">¿Cuánto puedo ahorrar mensualmente para mi retiro? <span className="requiredIn">*</span></label>
                                        <input type="text" maxLength="6" className="form-control browser-default" id="ahorro_mensualcot" name="ahorro_mensualcot"
                                        value={this.state.ahorro_mensualcot ? this.state.ahorro_mensualcot : ""}
                                        onChange={this.changeValues.bind(this)}/>
                                        {
                                            this.state.mensaje ? 
                                                this.validationMsj(this.state.mensaje.ahorro_mensualcot)
                                            :null
                                        }
                                        
                                    </div>
                                </div>

                                <div className=" col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center"  style={{marginTop:"10px",marginBottom:"10px"}}>
                                <button className="btn btn-gnp" onClick={this.regresar.bind(this)}>Regresar</button>
                                
                                <button className="btn btn-gnp" onClick={this.cotizar.bind(this)}>Cotizar</button> 
                                
                                
                            </div>
                        </div>
                    }
                </div>

                <ModalComponent propsModal={this.state.propsModal} mostrar={this.state.mostrar} />
                
                {
                    this.state.loading ? 
                    <div className="gnp-loading">
                        <div className="circle-orange"></div>
                        <div className="circle-blue"></div>
                        <div className="logo"><img src="https://storage.googleapis.com/static-portalcorporativo.gnp.com.mx/images/site/logo_header @1x.svg" 
                        className="fr-fic fr-dib" /></div>
                    </div>
                    : null
                }
            </div>
        )
    }

    regresar(event){
        window.location.reload();
    }
    parseInte(val){
        return parseInt(val);
    }
    validationMsj(msj){
        if(msj){
          return <p className="errorMsj text-left">{msj}</p>;  
        }
        return null;
    }
    changeValues(event){

        var name = event.target.name;
        var value = event.target.value;
        var mensaje = this.state.mensaje;

        this.setState({mostrar:false});
		mensaje[name] = null;
        this.setState({ [name]: value, mensaje,mostrar:false });

    }

    cotizar(event){
        var valido = this.valida();
        if(valido){
            var values = this.state.cotizacion.values;
            values.ahorro_mensual = this.state.ahorro_mensualcot;
            values.aportaciones = this.state.cotizacion.aportaciones;
            this.props.actions.cotizacion(values);
        }
    }

    recotizar(event){
        this.setState({mostrar:false})
        var valido = this.valida();


        if(valido){
            var values = this.state.cotizacion.values;


            values.ahorro_mensual = this.state.ahorro_mensualcot;
            values.aportaciones = this.state.cotizacion.aportaciones;
            values.recotiza = true;

            this.setState({loading:true});
            this.props.actions.cotizacion(values);
        }

        
    }

    valida(){
        var mensaje = this.state.mensaje;
        var valido = true;

        if(!this.state.ahorro_mensualcot){
            mensaje.ahorro_mensualcot = "Campo requerido."
            valido = false;
        }else{

            if(this.state.ahorro_mensualcot.trim()===""){
                mensaje.ahorro_mensualcot = "Campo requerido."
                valido = false;
            }else if(this.state.ahorro_mensualcot){
                var regex = /^\d{2,6}$/;
                if(!regex.test(this.state.ahorro_mensualcot) ){
                    mensaje.ahorro_mensualcot = "Capture un ahorro mensual válido."
                    valido = false;
                }else if(this.state.ahorro_mensualcot < 1000 || this.state.ahorro_mensualcot > 150000){
                    mensaje.ahorro_mensualcot = "El ahorro mensual mínimo es de $1,000 pesos y máximo de $150,000 pesos.";
                    valido=false;
                }
            }
        }

        this.setState({mensaje});

        return valido;
    }

    formatCurrency(e){
		e = e.toString().replace(/\$|,/g, "");
		if(isNaN(e)){
			e="0";
		}

		var sign =false; 
		
		if(e === Math.abs(e)){
			sign = e;
		}else{
			e = Math.floor(100 * e + .50000000001);
			sign = e;
		}

		let cents = e % 100;
		e = Math.floor(e / 100).toString();
		if(10 > cents){
			cents = "0"+cents;
		}
		for (var t = 0; t < Math.floor((e.length - (1 + t)) / 3); t++){
			 e = e.substring(0, e.length - (4 * t + 3)) + "," + e.substring(e.length - (4 * t + 3));
		}
		return (sign ? "" : "-") + e;
	
    }
    
    muestraAhorro(event){
        this.setState({reahorro:true,mostrar:false});
    }
}


const mapStateToProps = (state) => {
    return {
        successCotiza: state.todoReducer.get("successCotiza")
    };
  }
  const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({
            cotizacion : cotizacion,
            regresar: regresar
       }, dispatch)
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Cotizacion);



// WEBPACK FOOTER //
// ./src/Cotizacion.js